export const NameOfPermission = {
  events: 'Доступ к событиям питомца',
  medHistory: 'Медицинская история питомца',
  passport: 'Паспорт питомца',
  services: 'Все сервисы',
  sharing: 'Поделиться питомцем',
}
